<template>
  <v-container>
    <v-row no-gutters class="mt-3">
      <v-col cols="12" sm="6">
        <v-text-field
          label="Название прайс-листа"
          v-model="name"
          :rules="[v => !!v || 'Название не может быть пустым']"
          filled
          @blur="saveName()"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row no-gutters class="mt-3">
      <v-col cols="12" sm="8">
        <v-card outlined>
          <v-card-title>
            Этапы работ
            <v-spacer></v-spacer>

            <stage-card v-if="!isPartner"></stage-card>
          </v-card-title>

          <v-card-text>
            <v-data-table
              disable-pagination
              hide-default-footer
              :headers="stagesHeaders"
              :items="indexedStages"
            >
              <template v-slot:[`item.updown`]="{ item }">
                <up-down-elem
                  :id="item._id"
                  upFunc="prices/UP_STAGE"
                  downFunc="prices/DOWN_STAGE"
                  :key="item._id"
                ></up-down-elem>
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                <stage-card :id="item._id" :key="item._id"></stage-card>

                <delete-button
                  :id="item._id"
                  :deleteFunc="deleteStage"
                  objName="этап работ"
                >
                  Название: {{ item.name }}
                </delete-button>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import StageCard from './StageCard';

export default {
  name: 'price-settings',

  components: {
    StageCard
  },

  data() {
    let stagesHeaders = [
      {
        text: '',
        value: 'updown'
      },
      {
        text: '№',
        value: 'index'
      },
      {
        text: 'Название',
        value: 'name'
      },
      {
        text: 'Действия',
        value: 'actions'
      }
    ];
    return {
      name: this.$store.state.prices.curPrice.name,
      stagesHeaders: this.$store.getters['users/isPartner'] ? stagesHeaders.slice(1, 3) : stagesHeaders
    }
  },

  methods: {
    saveName() {
      if (this.name != '') {
        this.$store.commit('prices/SET_PRICE_NAME', this.name);
      }
    },

    async deleteStage(id) {
      this.$store.commit('prices/DELETE_STAGE', id);
      return { message: 'Этап работ успешно удален.' };
    }
  },

  computed: {
    ...mapState('prices', ['curPrice']),
    ...mapGetters('prices', ['indexedStages']),
    ...mapGetters('users', ['isPartner'])
  }
}
</script>